function renderDefaultFieldChangeHandlerTemplate({
  indent,
  defaultValueFromHandler
}: {
  indent: string
  defaultValueFromHandler: string
}): string {
  return `value={formField.value ?? ''}
${indent}          onChange={(event) => {
${indent}            ${defaultValueFromHandler}(event.target.value)
${indent}            formField.onChange(event)
${indent}          }}
${indent}          onBlur={formField.onBlur}
${indent}          name={formField.name}
${indent}          ref={formField.ref}`
}

function renderDefaultFieldFormFieldTemplate({
  indent,
  fieldName,
  formItemProps,
  labelWithDescription,
  fieldType,
  toLowerCase,
  fieldProps
}: {
  indent: string
  fieldName: string
  formItemProps: string
  labelWithDescription: string
  fieldType: string
  toLowerCase: string
  fieldProps: string
}): string {
  return `${indent}<FormField
${indent}  control={form.control}
${indent}  name="${fieldName}"
${indent}  render={({ field: formField }) => (
${indent}    <FormItem${formItemProps}>
${indent}      ${labelWithDescription}
${indent}      <FormControl>
${indent}        <Input
${indent}          type="${fieldType}"
${indent}          placeholder="Enter ${toLowerCase}"
${indent}          disabled={isPending}
${indent}          ${fieldProps}
${indent}        />
${indent}      </FormControl>
${indent}      <FormMessage />
${indent}    </FormItem>
${indent}  )}
${indent}/>`
}

export function renderDefaultFieldRenderer(
  request:
    | {
        kind: 'renderDefaultFieldChangeHandlerTemplate'
        props: {
          indent: string
          defaultValueFromHandler: string
        }
      }
    | {
        kind: 'renderDefaultFieldFormFieldTemplate'
        props: {
          indent: string
          fieldName: string
          formItemProps: string
          labelWithDescription: string
          fieldType: string
          toLowerCase: string
          fieldProps: string
        }
      }
): string {
  switch (request.kind) {
    case 'renderDefaultFieldChangeHandlerTemplate':
      return renderDefaultFieldChangeHandlerTemplate(request.props)
    case 'renderDefaultFieldFormFieldTemplate':
      return renderDefaultFieldFormFieldTemplate(request.props)
  }

  throw new Error('Unsupported renderer request')
}
